var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-wrapper"},[_c('van-loading',{staticClass:"load-one",attrs:{"type":"spinner","color":"#37357F"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209f7cd6","hasScoped":true,"transformToRequire":{"video":["app","poster"],"source":"app","img":"app","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/components/loading/ALloading.vue
// module id = null
// module chunks = 